/**
 * Utility functions for handling social media URLs
 */

/**
 * Cleans up Facebook URLs to remove duplicate domain prefixes
 *
 * Examples:
 * - "https://facebook.com/https://www.facebook.com/profile.php?id=123" -> "https://www.facebook.com/profile.php?id=123"
 * - "https://www.facebook.com/profile.php?id=123" -> "https://www.facebook.com/profile.php?id=123"
 * - "username" -> "https://facebook.com/username"
 *
 * @param facebookUrl The Facebook URL or username to clean
 * @returns A properly formatted Facebook URL
 */
export function cleanFacebookUrl(facebookUrl: string): string {
  if (!facebookUrl) return ""

  // Remove any leading/trailing whitespace
  const trimmed = facebookUrl.trim()

  // Check if the URL contains the duplicate facebook.com pattern
  const duplicatePattern =
    /^https?:\/\/(?:www\.)?facebook\.com\/(https?:\/\/(?:www\.)?facebook\.com\/.+)$/i
  const match = trimmed.match(duplicatePattern)

  if (match) {
    // Return the inner URL (the correct one)
    return match[1]
  }

  // If it's already a full Facebook URL, return as-is
  if (trimmed.match(/^https?:\/\/(?:www\.)?facebook\.com\//i)) {
    return trimmed
  }

  // If it's just a username or path, prepend facebook.com
  return `https://facebook.com/${trimmed}`
}
